/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreGroupDetailsResponse } from '../../models/store-group-details-response';

export interface GetStoreGroupById$Params {
  'Active-Tenant-Identifier': string;
  storeGroupId: string;
}

export function getStoreGroupById(http: HttpClient, rootUrl: string, params: GetStoreGroupById$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreGroupDetailsResponse>> {
  const rb = new RequestBuilder(rootUrl, getStoreGroupById.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeGroupId', params.storeGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreGroupDetailsResponse>;
    })
  );
}

getStoreGroupById.PATH = '/store-groups/{storeGroupId}';
